import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const cardStyle = {
  background: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  padding: "20px",
  marginBottom: "20px",
};

const teal = "#06d1c6";
const inputStyle = {
  width: "100%",
  padding: "8px 12px",
  border: `1px solid ${teal}`,
  borderRadius: "6px",
  backgroundColor: "#fff",
  color: "#334155",
  fontSize: "14px",
};

const GROUP_BY_OPTIONS = ["Fund", "Relationship Manager", "Sub Broker"];
const MONTH_COLUMNS = ["Apr'24", "May'24", "Jun'24", "Jul'24", "Aug'24", "Sep'24", "Oct'24", "Nov'24", "Dec'24", "Jan'25", "Feb'25", "Mar'25"];

export default function Analysis() {
  const [groupBy, setGroupBy] = useState("Sub Broker");
  const [selectUser, setSelectUser] = useState("");
  const [arn, setArn] = useState("All");
  const [rta, setRta] = useState("All");
  const [financialYear, setFinancialYear] = useState("FY 2024-2025");
  const [viewType, setViewType] = useState("onScreen");
  const [sortBy, setSortBy] = useState(null);
  const [sortDir, setSortDir] = useState("asc");

  const rows = []; // No data - empty state

  const handleApply = (e) => {
    e.preventDefault();
    console.log({ groupBy, selectUser, arn, rta, financialYear, viewType });
  };

  const toggleSort = (key) => {
    if (sortBy === key) setSortDir((d) => (d === "asc" ? "desc" : "asc"));
    else {
      setSortBy(key);
      setSortDir("asc");
    }
  };

  const SortIcon = ({ columnKey }) => (
    <button
      type="button"
      className="btn btn-link p-0 ms-1 border-0"
      style={{ color: sortBy === columnKey ? teal : "#64748b", fontSize: "11px" }}
      onClick={() => toggleSort(columnKey)}
      aria-label={`Sort by ${columnKey}`}
    >
      <i className={`fa fa-sort-${sortBy === columnKey ? (sortDir === "asc" ? "up" : "down") : "up"}`} style={{ opacity: sortBy === columnKey ? 1 : 0.4 }} />
    </button>
  );

  const groupByLabel = groupBy === "Sub Broker" ? "Sub Broker" : groupBy === "Relationship Manager" ? "Relationship Manager" : "Fund";

  return (
    <div className="main-content">
      <div className="page-wrapper page-settings">
        <div className="content">
          {/* Breadcrumb and Header */}
          <div className="mb-4" style={cardStyle}>
            <div className="content-page-header content-page-headersplit">
              <h5>Analysis</h5>
            </div>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/dashboard">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/admin/brokerage/income-detail">Brokerage</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Analysis
                </li>
              </ol>
            </nav>
          </div>

          {/* Filter card */}
          <div style={cardStyle}>
            <form onSubmit={handleApply}>
              <div className="mb-4">
                <label className="form-label small fw-semibold text-secondary mb-2 d-block">Group By :</label>
                <div className="d-flex flex-wrap gap-4">
                  {GROUP_BY_OPTIONS.map((opt) => (
                    <label key={opt} className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                      <input type="radio" name="groupBy" checked={groupBy === opt} onChange={() => setGroupBy(opt)} style={{ accentColor: teal }} />
                      {opt}
                    </label>
                  ))}
                </div>
              </div>

              <div className="mb-4">
                <label className="form-label small fw-semibold text-secondary mb-2 d-block">Filter:</label>
                <div className="row g-3">
                  <div className="col-12 col-md-3">
                    <label className="form-label small text-secondary mb-1 d-block">Select User</label>
                    <span className="position-relative d-inline-block w-100">
                      <select
                        value={selectUser}
                        onChange={(e) => setSelectUser(e.target.value)}
                        style={{
                          ...inputStyle,
                          background: teal,
                          color: "#fff",
                          borderColor: teal,
                          paddingLeft: 36,
                        }}
                      >
                        <option value="">Select User</option>
                      </select>
                      <span
                        className="position-absolute"
                        style={{ left: 10, top: "50%", transform: "translateY(-50%)", color: "rgba(255,255,255,0.9)", pointerEvents: "none" }}
                        aria-hidden
                      >
                        <i className="fa-solid fa-user" style={{ fontSize: "14px" }} />
                      </span>
                    </span>
                  </div>
                  <div className="col-12 col-md-3">
                    <label className="form-label small text-secondary mb-1 d-block">ARN</label>
                    <select value={arn} onChange={(e) => setArn(e.target.value)} style={inputStyle}>
                      <option value="All">All</option>
                    </select>
                  </div>
                  <div className="col-12 col-md-3">
                    <label className="form-label small text-secondary mb-1 d-block">RTA</label>
                    <select value={rta} onChange={(e) => setRta(e.target.value)} style={inputStyle}>
                      <option value="All">All</option>
                    </select>
                  </div>
                  <div className="col-12 col-md-3">
                    <label className="form-label small text-secondary mb-1 d-block">Financial Year</label>
                    <select value={financialYear} onChange={(e) => setFinancialYear(e.target.value)} style={inputStyle}>
                      <option value="FY 2024-2025">FY 2024-2025</option>
                      <option value="FY 2023-2024">FY 2023-2024</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="mb-4">
                <label className="form-label small fw-semibold text-secondary mb-2 d-block">View Type :</label>
                <div className="d-flex gap-4">
                  <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                    <input type="radio" name="viewType" checked={viewType === "onScreen"} onChange={() => setViewType("onScreen")} style={{ accentColor: teal }} />
                    On Screen
                  </label>
                  <label className="d-flex align-items-center gap-2 mb-0" style={{ cursor: "pointer" }}>
                    <input type="radio" name="viewType" checked={viewType === "xls"} onChange={() => setViewType("xls")} style={{ accentColor: teal }} />
                    XLS
                  </label>
                </div>
              </div>

              <div className="text-center">
                <button
                  type="submit"
                  style={{
                    background: teal,
                    color: "#fff",
                    border: "none",
                    padding: "10px 28px",
                    borderRadius: "8px",
                    fontWeight: 600,
                    fontSize: "15px",
                    cursor: "pointer",
                  }}
                >
                  Apply
                </button>
              </div>
            </form>
          </div>

          {/* Results table card */}
          <div style={{ ...cardStyle, padding: 0, overflowX: "auto" }}>
            <table className="table table-bordered mb-0" style={{ fontSize: "13px" }}>
              <thead>
                <tr style={{ backgroundColor: "#f8fafc" }}>
                  <th
                    className="text-nowrap"
                    style={{
                      padding: "10px 12px",
                      fontWeight: 600,
                      color: "#334155",
                      borderBottom: sortBy === groupByLabel ? `2px solid ${teal}` : undefined,
                    }}
                  >
                    {groupByLabel}
                    <SortIcon columnKey={groupByLabel} />
                    <i className="fa fa-search ms-1" style={{ fontSize: "11px", color: "#94a3b8" }} aria-hidden />
                  </th>
                  {MONTH_COLUMNS.map((month) => (
                    <th
                      key={month}
                      className="text-nowrap"
                      style={{
                        padding: "10px 12px",
                        fontWeight: 600,
                        color: "#334155",
                        borderBottom: sortBy === month ? `2px solid ${teal}` : undefined,
                      }}
                    >
                      {month}
                      <SortIcon columnKey={month} />
                    </th>
                  ))}
                  <th
                    className="text-nowrap"
                    style={{
                      padding: "10px 12px",
                      fontWeight: 600,
                      color: "#334155",
                      borderBottom: sortBy === "Total" ? `2px solid ${teal}` : undefined,
                    }}
                  >
                    Total
                    <SortIcon columnKey="Total" />
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan={MONTH_COLUMNS.length + 2} style={{ padding: "48px 24px", verticalAlign: "middle" }}>
                      <div className="text-center">
                        <div className="mb-2">
                          <i className="fa-solid fa-triangle-exclamation" style={{ fontSize: "42px", color: "#f59e0b" }} aria-hidden />
                        </div>
                        <div style={{ fontWeight: 600, color: "#334155" }}>No data available.</div>
                      </div>
                    </td>
                  </tr>
                ) : (
                  rows.map((row, idx) => (
                    <tr key={idx}>
                      <td style={{ padding: "10px 12px" }}>{row.label}</td>
                      {MONTH_COLUMNS.map((m) => (
                        <td key={m} style={{ padding: "10px 12px" }}>{row[m] ?? "—"}</td>
                      ))}
                      <td style={{ padding: "10px 12px" }}>{row.total ?? "—"}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
